import * as ko from "knockout";
import * as $ from "jquery";
import Bao from "./../services/bao-service";
ko.bindingHandlers.slideVisible = {
    init: function (element, valueAccessor) {
        var value = valueAccessor();
        $(element).hide();
    },
    update: function (element, valueAccessor) {
        var value = valueAccessor();
        ko.unwrap(value) ? $(element).slideDown(300) : $(element).slideUp(300);
    }
};